import React from 'react';
import ModifyLegal from './modify-legal';
import ModifyAddress from './modify-address';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';
import { classes } from './styles/modify';
import { Button } from 'reactstrap';

class Modify extends React.Component {

  render() {
    const {
      t,
      canSave,
      disabled,
      onSave,
      onCancel
    } = this.props;

    // Legal props
    const {
      isCustomer,
      customers,
      parentUuid,
      name,
      regulatoryLicense,
      onParentUuid,
      onName,
      onRegulatoryLicense
    } = this.props;

    // Address props
    const {
      line1,
      line2,
      city,
      zip,
      state,
      country,
      onLine1,
      onLine2,
      onCity,
      onZip,
      onState,
      onCountry
    } = this.props;

    return (
      <React.Fragment>
        <div className={classes.childContainer}>
          <ModifyLegal
            isCustomer={isCustomer}
            customers={customers}
            parentUuid={parentUuid}
            name={name}
            regulatoryLicense={regulatoryLicense}
            onParentUuid={onParentUuid}
            onName={onName}
            onRegulatoryLicense={onRegulatoryLicense}
            disabled={disabled}
          />
        </div>
        <div className={classes.childContainer}>
          <ModifyAddress
            line1={line1}
            line2={line2}
            city={city}
            zip={zip}
            state={state}
            country={country}
            onLine1={onLine1}
            onLine2={onLine2}
            onCity={onCity}
            onZip={onZip}
            onState={onState}
            onCountry={onCountry}
            disabled={disabled}
          />
        </div>
        <div className={classes.actionsContainer}>
          <Button
            color="primary"
            size="sm"
            disabled={!canSave || disabled}
            onClick={onSave}
          >
            {t('modify.saveAction')}
          </Button>
          <Button
            color="danger"
            size="sm"
            disabled={disabled}
            onClick={onCancel}
          >
            {t('modify.cancelAction')}
          </Button>
        </div>
      </React.Fragment>
    )
  }

}

Modify.propTypes = {
  ...ModifyLegal.propTypes,
  ...ModifyAddress.propTypes,
  onSave: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  canSave: PropTypes.bool.isRequired
};

export default translate(['customer'])(Modify);


// WEBPACK FOOTER //
// ./src/views/customer/modify.js